import React from 'react';
import ReportLayout, { fmtDateTime } from './ReportLayout';

const EVENT_COLORS = {
  entry:   'bg-emerald-100 text-emerald-700',
  exit:    'bg-orange-100 text-orange-700',
  return:  'bg-blue-100 text-blue-700',
  flagged: 'bg-red-100 text-red-700',
};

function EventChip({ value }) {
  const cls = EVENT_COLORS[value] ?? 'bg-zinc-100 text-zinc-600';
  return (
    <span className={`inline-flex px-2 py-0.5 rounded text-xs font-semibold capitalize ${cls}`}>
      {value}
    </span>
  );
}

const PASS_LABEL = {
  monthly:              'Monthly',
  exit_returnable:      'Exit Pass (Return)',
  exit_non_returnable:  'Exit Pass (One-way)',
};

const COLUMNS = [
  { key: 'employee_name',  label: 'Employee',   sortable: true },
  { key: 'employee_code',  label: 'Code',       sortable: false },
  { key: 'department',     label: 'Department', sortable: false },
  { key: 'supervisor_name',label: 'Supervisor', sortable: false },
  { key: 'event_type',     label: 'Event',      sortable: false, render: (v) => <EventChip value={v} /> },
  { key: 'timestamp',      label: 'Time',       sortable: true,  render: (v) => fmtDateTime(v) },
  { key: 'pass_type',      label: 'Pass',       sortable: false, render: (v) => PASS_LABEL[v] ?? v },
];

const FILTERS = [
  {
    type: 'search',
    name: 'department',
    label: 'Department',
    placeholder: 'Filter by dept…',
  },
  {
    type: 'userSelect',
    name: 'supervisor_id',
    label: 'Supervisor',
    role: 'supervisor',
  },
];

export default function EmployeeMovementReport() {
  return (
    <ReportLayout
      title="Employee Movement"
      description="Scan event log — every entry, exit and return for the day"
      endpoint="/reports/employee-movement"
      columns={COLUMNS}
      filters={FILTERS}
      defaultSort="timestamp"
      defaultOrder="desc"
      singleDate={true}
      exportFilename="employee-movement"
    />
  );
}
